// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function LabIconElement(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'LabIconElement',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M11.535 8.529L8.57 4.84V1.93a.214.214 0 01.215-.215H9A.857.857 0 009 0H3a.857.857 0 000 1.714h.214a.214.214 0 01.215.215v2.914L.465 8.529A2.143 2.143 0 00.22 10.8 2.176 2.176 0 002.162 12h7.676a2.176 2.176 0 001.943-1.2 2.143 2.143 0 00-.246-2.271zm-1.292 1.512a.45.45 0 01-.405.245H2.162a.45.45 0 01-.405-.246.41.41 0 01.043-.44l3.153-3.92a.857.857 0 00.19-.537V1.929a.214.214 0 01.214-.215h1.286a.214.214 0 01.214.215v3.214a.857.857 0 00.19.536L10.194 9.6a.411.411 0 01.049.44z',
      fill: 'currentColor',
    })
  );
}
